import { useTranslation } from "react-i18next";
import { useSearchList, useUpdateStatus } from "./service";
import { detail, update, status } from "./handlers";
import { RoomAddInfProvider, RoomBaseProvider } from "../context";
import RoomDetail from "../detail";
import RoomUpdate from "../update";
import useAlertStore from "store/alert";
import useModalStore from "store/modal";
import useMultiLangStore from "store/multiLang";
import Grid from "components/grid";
import ListHead from "components/subHead/listHead";

type IStatus = {
  uyn: string;
};
const ModalStatus = ({ uyn }: IStatus) => {
  const { t } = useTranslation();
  const nowStatus = uyn === "Y" ? t("uyn_y") : t("status_sell_n");
  const nextStatus = uyn === "Y" ? t("status_sell_n") : t("uyn_y");

  return (
    <div className="text-center font-bold">
      <h4>
        현재 객실상태는{" "}
        <span
          className={uyn === "Y" ? "text-green-500 px-1" : "text-red-600 px-1"}
        >
          [{nowStatus}]
        </span>
        입니다.
      </h4>
      <h4>
        객실상태를{" "}
        <span
          className={uyn === "Y" ? "text-red-600 px-1" : "text-green-600 px-1"}
        >
          [{nextStatus}]
        </span>
        변경하시겠습니까?
      </h4>
    </div>
  );
};

export default function RoomList() {
  const { t } = useTranslation();

  const { rowData, pageNavRef } = useSearchList();
  const { updateStatus } = useUpdateStatus();
  const onSetAlert = useAlertStore((state) => state.onSetAlert);
  const onSetModal = useModalStore((state) => state.onSetModal);
  const resetMultiLang = useMultiLangStore((state) => state.resetMultiLang);

  const theads = [
    ...prevHeads,
    {
      langNm: "grid_status",
      type: "uYn-btn",
      field: "uYn",
      width: 100,
      click: (props: any) => {
        status(props);
        onSetModal({
          isOpen: true,
          title: "상태변경",
          inner: <ModalStatus uyn={props.data.uyn} />,
          styles: "max-w-[380px]",
          chkBnt: true,
          keep: true,
          onSetConfirm: () => {
            onSetAlert({
              isOpen: true,
              inner: "객실상태를 변경하시겠습니까?",
              cnclBtn: true,
              onSetConfirm: updateStatus,
            });
          },
        });
      }, //상태변경
    },
    {
      langNm: "grid_detail",
      type: "detail",
      field: "detail",
      width: 100,

      click: (props: any) => {
        detail(props);
        onSetModal({
          isOpen: true,
          title: t("md_ttl_rm_detail"),
          styles: "w-full",
          cnclBtn: false,
          inner: (
            <RoomAddInfProvider>
              <RoomBaseProvider>
                <RoomDetail />
              </RoomBaseProvider>
            </RoomAddInfProvider>
          ),
          onSetClose: () => {
            resetMultiLang();
          },
        });
      }, // 상세
    },
    {
      langNm: "grid_modify",
      type: "modify",
      field: "update",
      width: 100,
      click: (props: any) => {
        update(props);
        onSetModal({
          isOpen: true,
          title: t("md_ttl_rm_edit"),
          styles: "w-full",
          cnclBtn: false,
          inner: (
            // 정보 수정완료 후 모달창 close 시 리스트 reSearch 여부 확인
            <RoomAddInfProvider>
              <RoomBaseProvider>
                <RoomUpdate />
              </RoomBaseProvider>
            </RoomAddInfProvider>
          ),
          onSetClose: () => {
            resetMultiLang();
          },
        });
      }, // 수정
    },
  ];

  return (
    <>
      <ListHead totalRows={pageNavRef.current.totalRows} />
      <Grid theads={theads} rowData={rowData} pageNav={pageNavRef.current} />
    </>
  );
}

const prevHeads = [
  {
    langNm: "grid_no",
    type: "id",
    field: "No",
    width: 60,
  },
  {
    langNm: "grid_rm_no",
    type: "string",
    field: "rmNo",
  },
  {
    langNm: "grid_rm_nm",
    type: "string",
    field: "rmNm",
  },
  {
    langNm: "grid_rm_typ",
    type: "string",
    field: "rmTypNm",
  },
  {
    langNm: "grid_rm_olk",
    type: "string",
    field: "rmOlkNm",
  },
  {
    langNm: "grid_max_per_ct",
    type: "string",
    field: "maxPerCt",
  },
  {
    langNm: "grid_regi_sts",
    type: "status",
    field: "regiSt",
  },
];
